import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function JobBasicSettings() {
    return (
        <React.Fragment>
            <p>
                Use the <strong>Notification and Logging</strong> settings to send email notifications about job
                activity.
            </p>
            <p>
                A job's <strong>Email condition</strong> determines when to send an email to a set of recipients, and
                can be set using a <strong>To</strong>, <strong>CC</strong>, and <strong>BCC</strong> field, including
                multiple recipient addresses using a comma.
            </p>
            <p>
                <strong>Email Job Failure Reports To</strong> allows you to set recipients to be notified when a job
                fails.
            </p>
            <p>
                Set <strong>Job Scheduling</strong> to run a job on a regular basis, or for a specific date and time.
            </p>
        </React.Fragment>
    );
}

JobBasicSettings.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(JobBasicSettings);
